import FacebookService from './FacebookService';
import 'l10nModule';

export default angular.module('edge.platform.facebook', ['edge.platform.l10n']).provider('FacebookService', FacebookService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/facebook/module.js
// module id = 314
// module chunks = 0